"use client";

import { cn } from "@/lib/utils";

import {
	MAX_COMPOSER_MESSAGE_LENGTH,
	shouldShowComposerLengthCounter,
} from "@/app/profile/inbox/(chats)/components/SupportTickets/supportTicketMessageUtils";

type ComposerLengthCounterProps = {
	length: number;
	maxLength?: number;
	className?: string;
};

export default function ComposerLengthCounter({
	length,
	maxLength = MAX_COMPOSER_MESSAGE_LENGTH,
	className,
}: ComposerLengthCounterProps) {
	if (!shouldShowComposerLengthCounter(length)) return null;

	const isOverLimit = length > maxLength;

	return (
		<span
			className={cn(
				"pointer-events-none text-[10px] font-medium",
				isOverLimit ? "text-destructive" : "text-muted-foreground",
				className,
			)}
		>
			{length}/{maxLength}
		</span>
	);
}
